var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentOptionalSkillsFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 22a1.54 1.54 0 01-1.13-.47 1.541 1.541 0 01-.47-1.13h3.2c0 .44-.157.817-.47 1.13-.313.313-.69.47-1.13.47zm-5.19-7a6.113 6.113 0 001.99 2.076V18.8h6.4v-1.724A6.12 6.12 0 0017.19 15c.54-.92.81-1.92.81-3 0-1.667-.584-3.083-1.75-4.25C15.083 6.583 13.667 6 12 6c-1.667 0-3.083.583-4.25 1.75C6.583 8.917 6 10.333 6 12c0 1.08.27 2.08.81 3zM12 17h-.75v-3.2H9L12 9h.75v3.2H15L12 17z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2h1v3h-1V2zm6.621 2l.707.707-2.121 2.121L16 6.121 18.12 4zM5.707 4L5 4.707l2.12 2.121.707-.707L5.707 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentOptionalSkillsFill);
export default __webpack_public_path__ + "c705c439b082d15f569e12e2bbaf3c8e.svg";
export { ForwardRef as ReactComponent };